// Contenu de la page d'accueil promotionnelle (objectif unique : réserver une démo de 30 min).
export const HOME = {
  fr: {
    cta: {
      label: "Réserver ma démo de 30 min",
      sub: "Réponse sous 48 h.",
    },
    hero: {
      eyebrow: "Le management, mesuré. Pas deviné.",
      h1a: "Vos KPIs mesurent la performance.",
      h1b: "Cayus mesure le leadership qui la produit.",
      sub: "Avec son accord, chaque manager voit dans Microsoft Teams ce que ses habitudes produisent, et une seule chose à améliorer cette semaine.",
      secondary: "Comprendre la méthodologie",
      badges: ["Application Microsoft Teams", "Des mots, jamais des notes", "Conforme RGPD & EU AI Act"],
      caption: "L'onglet Cayus du manager",
    },
    problem: {
      eyebrow: "L'angle mort",
      title: "Personne ne voit comment vos managers managent. Vous, si. Bientôt.",
      stats: [
        { value: "9,7 %", desc: "des départs sont causés par le management. Et ce chiffre monte chaque année.", source: "Source : Work Institute, 2025" },
        { value: "35 000 €+", desc: "par départ. Recrutement, formation, montée en compétence : la facture d'un management qu'on ne voit pas.", source: "Source : Oxford Economics" },
      ],
      transition: "Une enquête, c'est un ressenti un mardi de novembre. Cayus, ce sont des faits en continu.",
    },
    steps: {
      eyebrow: "La mise en place",
      title: "Trois étapes. Zéro formation. Zéro nouvel outil.",
      items: [
        { t: "Chacun donne son accord", d: "Chaque manager connecte son compte lui-même, et le déconnecte quand il veut. Sans son accord : rien." },
        { t: "Les preuves s'accumulent", d: "Cayus lit huit semaines de travail dans Teams. Chaque message : lu une fois, transformé en observation, effacé." },
        { t: "Chacun ouvre son onglet", d: "Dans son onglet Teams, chaque manager trouve un comportement à travailler cette semaine. Un seul. C'est ce qui le rend tenable." },
      ],
      closing: "Il ne sortira jamais de Cayus ni un score, ni un classement, ni un nom.",
    },
    wall: {
      viz: {
        label: "Le mur, en direct",
        msgs: [
          { text: "« Tu peux regarder ça ? »", out: "Clarté des demandes", lvl: "Consistent", conf: false },
          { text: "« Merci, beau travail »", out: "Reconnaissance", lvl: "Establishing", conf: false },
          { text: "Message confidentiel", out: null, lvl: null, conf: true },
          { text: "« Un point de 30 minutes ? »", out: "Investissement relationnel", lvl: "En progrès", conf: false },
        ],
        err: "Écrivez d'abord un message",
        placeholderAfter: "Regardez-le se dissoudre…",
        confLabel: "⬡ CONFIDENTIEL",
        neverRead: "Jamais lu",
        in: "Ce qui entre",
        out: "Ce qui en sort",
        wall: "LE MUR",
        pairs: [
          { msg: "« Tu peux regarder ça ? »", obs: "Clear asks", level: "Consistent" },
          { msg: "Un point de 30 minutes", obs: "Relationship investment", level: "Establishing" },
          { msg: "« Merci, beau travail »", obs: "Recognition", level: "Establishing" },
        ],
        demoLabel: "Écrivez un message, voyez ce qu'il en reste",
        placeholder: "Bonjour, peux-tu regarder ça avant vendredi ?",
        button: "Envoyer contre le mur",
        userObs: "Observation extraite",
        userLevel: "Le texte a disparu",
        privacy: "Tout se passe dans votre navigateur. Rien n'est envoyé, nulle part.",
        counter: "Messages conservés : 0",
      },
      eyebrow: "Confidentialité",
      title: "Ce qui entre ne ressort jamais.",
      note: "Lu une fois. Transformé en observation. Effacé. Il ne traverse le mur que des mots : jamais un nom, jamais un score.",
      guarantees: [
        { t: "Chaque manager est seul à se voir.", d: "Ce que voit un manager n'est visible que de lui. Les RH voient des groupes de 8 minimum, jamais une personne." },
        { t: "Rien n'est conservé.", d: "Zéro conversation stockée. Zéro historique. Et un message marqué confidentiel n'est même pas lu." },
        { t: "Vos données ne quittent jamais chez vous.", d: "Tout tourne dans votre Microsoft 365, derrière votre sécurité. RGPD, EU AI Act, et un dossier prêt pour votre CSE." },
      ],
      link: "Voir la sécurité & la conformité en détail",
    },
    contrast: {
      eyebrow: "Avant / après",
      title: "Le même trimestre, vu de deux façons.",
      beforeLabel: "Sans Cayus",
      afterLabel: "Avec Cayus",
      before: [
        "Vous apprenez qu'un manager décroche le jour de sa démission.",
        "« Il faut mieux communiquer. » Et lundi matin, personne ne sait quoi faire de plus.",
        "L'enquête recueille ce qu'on veut bien déclarer.",
      ],
      after: [
        "Vous voyez la relation se fragiliser quand un café suffit encore à la réparer.",
        "Chaque manager a une seule chose à travailler cette semaine.",
        "Vous voyez ce qui se fait réellement, service par service, à temps pour agir.",
      ],
      hint: "Glissez pour comparer",
      quote: "On a enfin eu des mots pour dire ce qu'un bon manager fait vraiment. Plus une impression : des faits.",
      author: "DRH, ETI de 250 salariés · après 8 semaines de pilote",
    },
    final: {
      badge: "Programme pilote · 2 organisations à bord · 3 places restantes",
      title: "Vos KPIs n'ont jamais vu ça.",
      text: "Nous construisons Cayus avec 5 organisations pionnières. Il en reste 3 à choisir. En 30 minutes, vous voyez l'écran exact de vos managers, de vos RH, de votre comité. Et vous repartez avec le dossier exécutif de 2 pages qui convaincra en interne.",
      micro: "Réponse sous 48 h. Le dossier exécutif (2 pages) arrive dans votre boîte à l'instant même.",
    },
    form: {
      sizeQuestion: "Combien de collaborateurs ?",
      emptyEmail: "Il nous faut votre email professionnel pour vous répondre.",
    },
    success: {
      title: "C'est noté",
      message: "C'est noté. Le dossier exécutif est déjà dans votre boîte, et nous revenons vers vous sous 48 h avec un créneau.",
    },
    faq: {
      title: "Questions fréquentes",
      items: [
        {
          q: "Les RH peuvent-elles voir ce que fait un manager en particulier ?",
          a: "Non. Jamais. Ni aujourd'hui, ni sur demande, ni « en cas de besoin ». Les RH voient des groupes de 8 minimum ; ce que voit un manager n'appartient qu'à lui.",
        },
        {
          q: "Quelles données Cayus analyse-t-il ?",
          a: "Les habitudes de travail visibles dans Teams : demandes, réponses, reconnaissance, rythme. Lu une fois. Transformé en observation. Effacé. Un message marqué confidentiel n'est même pas lu.",
        },
        {
          q: "Cayus est-il conforme au RGPD et à l'EU AI Act ?",
          a: "Oui, et c'est vérifiable. Confidentialité dès la conception, données qui ne quittent jamais votre Microsoft 365, dossier CSE prêt à présenter. Le détail est public :",
          link: { label: "Voir la page Sécurité & conformité", to: "/securite" },
        },
        {
          q: "Combien de temps pour voir des résultats ?",
          a: "Premières observations : semaine 1. Premier progrès mesurable : semaine 6. Pas de promesse de transformation en trois jours : des comportements qui tiennent.",
        },
        {
          q: "Faut-il installer une plateforme séparée ?",
          a: "Non. Un onglet dans Teams, c'est tout. Pas de mot de passe, pas de formation, pas d'app de plus.",
        },
      ],
      foot: "Une question qui n'est pas ici ? Elle tiendra dans les 30 minutes.",
    },
  },

  en: {
    cta: {
      label: "Book my 30-minute demo",
      sub: "Answer within 48 hours.",
    },
    hero: {
      eyebrow: "Management, measured. Not guessed.",
      h1a: "Your KPIs measure performance.",
      h1b: "Cayus measures the leadership behind it.",
      sub: "With their consent, each manager sees in Microsoft Teams what their habits produce, and one single thing to improve this week.",
      secondary: "Understand the methodology",
      badges: ["Microsoft Teams app", "Words, never grades", "GDPR & EU AI Act ready"],
      caption: "The manager's Cayus tab",
    },
    problem: {
      eyebrow: "The blind spot",
      title: "Nobody sees how your managers manage. You will. Soon.",
      stats: [
        { value: "9.7%", desc: "of departures are caused by management. And that number climbs every year.", source: "Source: Work Institute, 2025" },
        { value: "€35,000+", desc: "per departure. Hiring, training, getting up to speed: the bill for management nobody can see.", source: "Source: Oxford Economics" },
      ],
      transition: "A survey is how someone felt on a Tuesday in November. Cayus is facts, continuously.",
    },
    steps: {
      eyebrow: "Getting started",
      title: "Three steps. Zero training. Zero new tools.",
      items: [
        { t: "Everyone gives consent", d: "Each manager connects their own account, and disconnects it whenever they want. Without their consent: nothing." },
        { t: "Evidence builds up", d: "Cayus reads eight weeks of work in Teams. Each message: read once, turned into an observation, deleted." },
        { t: "Everyone opens their tab", d: "In their Teams tab, each manager finds one behaviour to work on this week. Just one. That is what makes it stick." },
      ],
      closing: "No score, no ranking and no name will ever leave Cayus.",
    },
    wall: {
      viz: {
        label: "The wall, live",
        msgs: [
          { text: "\"Can you take a look at this?\"", out: "Clear asks", lvl: "Consistent", conf: false },
          { text: "\"Thanks, great work\"", out: "Recognition", lvl: "Establishing", conf: false },
          { text: "Confidential message", out: null, lvl: null, conf: true },
          { text: "\"A 30-minute check-in?\"", out: "Relationship investment", lvl: "In progress", conf: false },
        ],
        err: "Write a message first",
        placeholderAfter: "Watch it dissolve…",
        confLabel: "⬡ CONFIDENTIAL",
        neverRead: "Never read",
        in: "What goes in",
        out: "What comes out",
        wall: "THE WALL",
        pairs: [
          { msg: "\"Can you take a look at this?\"", obs: "Clear asks", level: "Consistent" },
          { msg: "A 30-minute check-in", obs: "Relationship investment", level: "Establishing" },
          { msg: "\"Thanks, great work\"", obs: "Recognition", level: "Establishing" },
        ],
        demoLabel: "Write a message, see what is left of it",
        placeholder: "Hi, could you look at this before Friday?",
        button: "Send it against the wall",
        userObs: "Observation extracted",
        userLevel: "The text is gone",
        privacy: "Everything happens in your browser. Nothing is sent anywhere.",
        counter: "Messages kept: 0",
      },
      eyebrow: "Privacy",
      title: "What goes in never comes back out.",
      note: "Read once. Turned into an observation. Deleted. Only words cross the wall: never a name, never a score.",
      guarantees: [
        { t: "Each manager is the only one who sees themselves.", d: "What a manager sees is visible to them alone. HR sees groups of 8 or more, never a person." },
        { t: "Nothing is kept.", d: "Zero conversations stored. Zero history. And a message marked confidential is not even read." },
        { t: "Your data never leaves your house.", d: "Everything runs inside your own Microsoft 365, behind your security. GDPR, EU AI Act, and a pack ready for your works council." },
      ],
      link: "See security & compliance in detail",
    },
    contrast: {
      eyebrow: "Before / after",
      title: "The same quarter, seen two ways.",
      beforeLabel: "Without Cayus",
      afterLabel: "With Cayus",
      before: [
        "You learn a manager has checked out on the day they resign.",
        "\"Communicate better.\" And on Monday morning, nobody knows what to do differently.",
        "The survey collects what people are willing to declare.",
      ],
      after: [
        "You see a relationship cooling while a coffee still repairs it.",
        "Every manager has one thing to work on this week.",
        "You see what is actually being done, unit by unit, in time to act.",
      ],
      hint: "Drag to compare",
      quote: "We finally had words for what a good manager actually does. Not an impression any more: facts.",
      author: "HR director, 250-person company · after an 8-week pilot",
    },
    final: {
      badge: "Pilot programme · 2 organisations on board · 3 places left",
      title: "Your KPIs have never seen this.",
      text: "We are building Cayus with 5 pioneering organisations. 3 places are still ours to fill. In 30 minutes you see the exact screen of your managers, your HR team, your committee. And you leave with the two-page executive brief that will convince them internally.",
      micro: "Answer within 48 hours. The executive brief (2 pages) lands in your inbox this very moment.",
    },
    form: {
      sizeQuestion: "How many people work with you?",
      emptyEmail: "We need your work email to get back to you.",
    },
    success: {
      title: "Noted",
      message: "Noted. The executive brief is already in your inbox, and we'll come back to you within 48 hours with a slot.",
    },
    faq: {
      title: "Frequently asked questions",
      items: [
        {
          q: "Can HR see what an individual manager does?",
          a: "No. Never. Not today, not on request, not \"if we really need to\". HR sees groups of 8 or more; what a manager sees belongs to them alone.",
        },
        {
          q: "What data does Cayus analyse?",
          a: "The working habits visible in Teams: requests, replies, recognition, rhythm. Read once. Turned into an observation. Deleted. A message marked confidential is not even read.",
        },
        {
          q: "Is Cayus GDPR and EU AI Act compliant?",
          a: "Yes, and it can be checked. Privacy by design, data that never leaves your Microsoft 365, a works council pack ready to present. The detail is public:",
          link: { label: "See the Security & compliance page", to: "/securite" },
        },
        {
          q: "How long before we see results?",
          a: "First observations: week 1. First measurable progress: week 6. No promise of transformation in three days: behaviours that hold.",
        },
        {
          q: "Do we need to install a separate platform?",
          a: "No. One tab inside Teams, that is all. No password, no training, no extra app.",
        },
      ],
      foot: "A question that isn't here? It will fit in the 30 minutes.",
    },
  },

  es: {
    cta: {
      label: "Reservar mi demo de 30 min",
      sub: "Respuesta en 48 h.",
    },
    hero: {
      eyebrow: "La gestión, medida. No adivinada.",
      h1a: "Sus KPIs miden el rendimiento.",
      h1b: "Cayus mide el liderazgo que lo produce.",
      sub: "Con su consentimiento, cada manager ve en Microsoft Teams lo que producen sus hábitos, y una sola cosa que mejorar esta semana.",
      secondary: "Entender la metodología",
      badges: ["Aplicación de Microsoft Teams", "Palabras, nunca notas", "Conforme al RGPD y al Reglamento europeo de IA"],
      caption: "La pestaña Cayus del manager",
    },
    problem: {
      eyebrow: "El punto ciego",
      title: "Nadie ve cómo dirigen sus managers. Usted sí. Pronto.",
      stats: [
        { value: "9,7 %", desc: "de las salidas están causadas por la gestión. Y esa cifra sube cada año.", source: "Fuente: Work Institute, 2025" },
        { value: "35 000 €+", desc: "por salida. Contratación, formación, puesta al día: la factura de una gestión que no se ve.", source: "Fuente: Oxford Economics" },
      ],
      transition: "Una encuesta es cómo se sintió alguien un martes de noviembre. Cayus son hechos, en continuo.",
    },
    steps: {
      eyebrow: "La puesta en marcha",
      title: "Tres pasos. Cero formación. Cero herramientas nuevas.",
      items: [
        { t: "Cada uno da su consentimiento", d: "Cada manager conecta su cuenta él mismo, y la desconecta cuando quiera. Sin su consentimiento: nada." },
        { t: "Las evidencias se acumulan", d: "Cayus lee ocho semanas de trabajo en Teams. Cada mensaje: leído una vez, convertido en observación, borrado." },
        { t: "Cada uno abre su pestaña", d: "En su pestaña de Teams, cada manager encuentra un comportamiento que trabajar esta semana. Uno solo. Por eso se sostiene." },
      ],
      closing: "Nunca saldrá de Cayus ni una puntuación, ni una clasificación, ni un nombre.",
    },
    wall: {
      viz: {
        label: "El muro, en directo",
        msgs: [
          { text: "«¿Puedes mirar esto?»", out: "Claridad de las peticiones", lvl: "Consistent", conf: false },
          { text: "«Gracias, buen trabajo»", out: "Reconocimiento", lvl: "Establishing", conf: false },
          { text: "Mensaje confidencial", out: null, lvl: null, conf: true },
          { text: "«¿Un punto de 30 minutos?»", out: "Inversión en la relación", lvl: "En progreso", conf: false },
        ],
        err: "Escriba primero un mensaje",
        placeholderAfter: "Mírelo disolverse…",
        confLabel: "⬡ CONFIDENCIAL",
        neverRead: "Nunca leído",
        in: "Lo que entra",
        out: "Lo que sale",
        wall: "EL MURO",
        pairs: [
          { msg: "«¿Puedes mirar esto?»", obs: "Clear asks", level: "Consistent" },
          { msg: "Un punto de 30 minutos", obs: "Relationship investment", level: "Establishing" },
          { msg: "«Gracias, buen trabajo»", obs: "Recognition", level: "Establishing" },
        ],
        demoLabel: "Escriba un mensaje y vea qué queda de él",
        placeholder: "Hola, ¿puedes mirar esto antes del viernes?",
        button: "Lanzar contra el muro",
        userObs: "Observación extraída",
        userLevel: "El texto ha desaparecido",
        privacy: "Todo ocurre en su navegador. Nada se envía a ninguna parte.",
        counter: "Mensajes conservados: 0",
      },
      eyebrow: "Privacidad",
      title: "Lo que entra no vuelve a salir.",
      note: "Leído una vez. Convertido en observación. Borrado. Solo cruzan el muro palabras: nunca un nombre, nunca una puntuación.",
      guarantees: [
        { t: "Cada manager es el único que se ve.", d: "Lo que ve un manager solo lo ve él. RRHH ve grupos de 8 como mínimo, nunca a una persona." },
        { t: "Nada se conserva.", d: "Cero conversaciones almacenadas. Cero historial. Y un mensaje marcado como confidencial ni siquiera se lee." },
        { t: "Sus datos nunca salen de su casa.", d: "Todo funciona en su propio Microsoft 365, detrás de su seguridad. RGPD, Reglamento europeo de IA, y un dosier listo para su comité de empresa." },
      ],
      link: "Ver la seguridad y la conformidad en detalle",
    },
    contrast: {
      eyebrow: "Antes / después",
      title: "El mismo trimestre, visto de dos maneras.",
      beforeLabel: "Sin Cayus",
      afterLabel: "Con Cayus",
      before: [
        "Se entera de que un manager se ha descolgado el día que renuncia.",
        "«Hay que comunicar mejor.» Y el lunes por la mañana, nadie sabe qué hacer distinto.",
        "La encuesta recoge lo que cada uno quiere declarar.",
      ],
      after: [
        "Ve la relación enfriarse cuando un café todavía la arregla.",
        "Cada manager tiene una sola cosa que trabajar esta semana.",
        "Ve lo que se hace realmente, unidad por unidad, a tiempo para actuar.",
      ],
      hint: "Arrastre para comparar",
      quote: "Por fin tuvimos palabras para decir lo que hace de verdad un buen manager. Ya no una impresión: hechos.",
      author: "Directora de RRHH, empresa de 250 personas · tras 8 semanas de piloto",
    },
    final: {
      badge: "Programa piloto · 2 organizaciones a bordo · 3 plazas libres",
      title: "Sus KPIs nunca han visto esto.",
      text: "Construimos Cayus con 5 organizaciones pioneras. Quedan 3 plazas por elegir. En 30 minutos ve la pantalla exacta de sus managers, de RRHH, de su comité. Y se va con el dosier ejecutivo de dos páginas que convencerá internamente.",
      micro: "Respuesta en 48 h. El dosier ejecutivo (2 páginas) llega a su buzón en este mismo instante.",
    },
    form: {
      sizeQuestion: "¿Cuántas personas trabajan con usted?",
      emptyEmail: "Necesitamos su email profesional para responderle.",
    },
    success: {
      title: "Anotado",
      message: "Anotado. El dosier ejecutivo ya está en su buzón, y le responderemos en 48 h con una cita.",
    },
    faq: {
      title: "Preguntas frecuentes",
      items: [
        {
          q: "¿Puede RRHH ver lo que hace un manager en concreto?",
          a: "No. Nunca. Ni hoy, ni a petición, ni «en caso de necesidad». RRHH ve grupos de 8 como mínimo; lo que ve un manager solo le pertenece a él.",
        },
        {
          q: "¿Qué datos analiza Cayus?",
          a: "Los hábitos de trabajo visibles en Teams: peticiones, respuestas, reconocimiento, ritmo. Leído una vez. Convertido en observación. Borrado. Un mensaje marcado como confidencial ni siquiera se lee.",
        },
        {
          q: "¿Cumple Cayus el RGPD y el Reglamento europeo de IA?",
          a: "Sí, y es verificable. Privacidad desde el diseño, datos que nunca salen de su Microsoft 365, dosier ejecutivo listo para presentar. El detalle es público:",
          link: { label: "Ver la página Seguridad y conformidad", to: "/securite" },
        },
        {
          q: "¿Cuánto tiempo hasta ver resultados?",
          a: "Primeras observaciones: semana 1. Primer progreso medible: semana 6. Ninguna promesa de transformación en tres días: comportamientos que se sostienen.",
        },
        {
          q: "¿Hay que instalar una plataforma aparte?",
          a: "No. Una pestaña dentro de Teams, y ya está. Sin contraseña, sin formación, sin otra app.",
        },
      ],
      foot: "¿Una pregunta que no está aquí? Cabe en los 30 minutos.",
    },
  },
};

export const useHome = (language) => HOME[language] || HOME.fr;
export default HOME;
